module.exports = __webpack_public_path__ + "static/img/horusCrownedEagle.144ff74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/horusCrownedEagle.png
// module id = 68
// module chunks = 1